<!--
 * @Description: 项目根组件
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-04-05 13:14:48
 -->
<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶部导航栏 -->
<!--      <div class="topbar">
        <div class="nav">
          <ul>
            <li v-if="false">
              <el-button type="text" @click="login">登录</el-button>
              <span class="sep">|</span>
              <el-button type="text" @click="register = true">注册</el-button>
            </li>
            <li v-else>
              欢迎
              <el-popover placement="top" width="180" v-model="visible">
                <p>确定退出登录吗？</p>
                <div style="text-align: right; margin: 10px 0 0">
                  <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="logout">确定</el-button>
                </div>
                <el-button type="text"  >xx</el-button>
              </el-popover>
            </li>
            <li>
              <router-link to="/order">我的订单</router-link>
            </li>
            <li>
              <router-link to="/collect">我的收藏</router-link>
            </li>
            <li :class="getNum > 0 ? 'shopCart-full' : 'shopCart'">
              <router-link to="/shoppingCart">
                <i class="el-icon-shopping-cart-full"></i> 购物车
                <span class="num">({{getNum}})</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>-->
      <!-- 顶部导航栏END -->

      <!-- 顶栏容器 -->
      <el-header style="margin-top: 10px;">
        <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#409eff"
            router
        >
          <div class="logo" style="width: 10%;" >
            <router-link to="/">
              <span style="position: sticky; top: 15px; left: 50px; font-size: 30px;">天汇云</span>
            </router-link>
          </div>
          <!-- <el-menu-item index="/" >首页</el-menu-item>
          <el-menu-item index="/news" >新闻</el-menu-item>
          <el-menu-item index="/case" >案例</el-menu-item>
          <el-menu-item index="/about" >关于我们</el-menu-item> -->

          <div class="so" v-show="searchVisible">
            <el-input placeholder="请输入搜索内容" v-model="search"   class="w-50 m-2" >
              <template #suffix>
                <el-icon class="el-input__icon"  @click="searchClick"><search /></el-icon>
              </template>
            </el-input>
          </div>
        </el-menu>
      </el-header>
      <!-- 顶栏容器END -->

      <!-- 登录模块 -->
      <!--      <MyLogin></MyLogin>-->
      <!-- 注册模块 -->
      <!--      <MyRegister :register="register" @fromChild="isRegister"></MyRegister>-->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view :key="$route.path+$route.query"></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
            <el-row :gutter="25">
              <!-- <el-col :span="6" >
                <div style="width: 100%; color: #c6cbd1; margin: 25px 10px; font-size: 20px"> 服务热线 </div>
                <div style="color: #14cb85; font-size: 18px">
                  <span> <el-icon color="#14cb85"> <phone /> </el-icon>  18600296945</span>
                </div>
              </el-col>

              <el-col :span="6" >
                <div style="width: 100%; color: #c6cbd1; margin: 25px 10px; font-size: 20px"> 案例 </div>
                <div style="width: 100%; color: #b0b0b0; margin: 25px 10px"> <router-link to="/case" style="color: #6a737d;font-size: 17px ">项目案例</router-link>  </div>
              </el-col>

              <el-col :span="6" >
                <div style="width: 100%; color: #c6cbd1; margin: 25px 10px; font-size: 20px"> 新闻 </div>
                <div style="width: 100%; color: #b0b0b0; margin: 25px 10px"> <router-link to="/news" style="color: #6a737d;font-size: 17px ">公司新闻</router-link>  </div>
                <div style="width: 100%; color: #b0b0b0; margin: 25px 10px"> <router-link to="/news" style="color: #6a737d;font-size: 17px ">行业动态</router-link>  </div>
              </el-col>

              <el-col :span="6" >
                <div style="width: 100%; color: #c6cbd1; margin: 25px 10px; font-size: 20px"> 关于 </div>
                <div style="width: 100%; margin: 25px 10px">  <router-link to="/about" style="color: #6a737d;font-size: 17px ">关于我们</router-link> </div>
              </el-col> -->
            </el-row>

            <div style="width: 100%; color: #b0b0b0; margin: 25px 10px">地址：成都市锦江区 </div>
            <div style="width: 100%; color: #b0b0b0; margin: 25px 10px"> 邮编：610000 </div>

            <div class="mod_help">
              <p class="coty"><a href="https://beian.miit.gov.cn">蜀ICP备2024078324号-1</a> &copy; 2021-2026 kelvin</p>
            </div>

          </div>

      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>


import { Search } from '@element-plus/icons-vue'

export default {
  data() {
    return {
      activeIndex: "", // 头部导航栏选中的标签
      search: "", // 搜索条件
      register: false, // 是否显示注册组件
      visible: false, // 是否退出登录
      searchVisible : false //是否显示搜索组件
    };
  },
  // 通过路由获取商品id
  activated() {
    if (this.$route.query.productID != undefined) {
      this.productID = this.$route.query.productID;
    }
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem("user")) {
      // 如果已经登录，设置vuex登录状态
      // this.setUser(JSON.parse(localStorage.getItem("user")));
    }
    /* window.setTimeout(() => {
      this.$message({
        duration: 0,
        showClose: true,
        message: `
        <p>如果觉得这个项目还不错，</p>
        <p style="padding:10px 0">您可以给项目源代码仓库点Star支持一下，谢谢！</p>
        <p><a href="https://github.com/xxx/vue-store" target="_blank">Github传送门</a></p>`,
        dangerouslyUseHTMLString: true,
        type: "success"
      });
    }, 1000 * 60); */
  },
  computed: {
  },
  watch: {
    // 监听路由变化，更新路由传递了搜索条件
    $route: function(val) {
      if(val.path == "/news" ) {
        this.searchVisible = true;
      } else {
        this.searchVisible = false;
      }
      this.activeIndex = val.path;
    }
  },
  methods: {
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      // this.setShowLogin(true);
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != "") {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: "/news", query: { search: this.search } });
        // this.search = "";
      } else {
        this.$message.info("请输入搜索内容！")
      }
    }
  }
};
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}
#app .el-header {
  padding: 0;
}
#app .el-main {
  min-height: 300px;
  padding: 20px 0;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 顶部导航栏CSS */
.topbar {
  height: 40px;
  background-color: #3d3d3d;
  margin-bottom: 20px;
}
.topbar .nav {
  width: 1225px;
  margin: 0 auto;
}
.topbar .nav ul {
  float: right;
}
.topbar .nav li {
  float: left;
  height: 40px;
  color: #b0b0b0;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  margin-left: 20px;
}
.topbar .nav .sep {
  color: #b0b0b0;
  font-size: 12px;
  margin: 0 5px;
}
.topbar .nav li .el-button {
  color: #b0b0b0;
}
.topbar .nav .el-button:hover {
  color: #fff;
}
.topbar .nav li a {
  color: #b0b0b0;
}
.topbar .nav a:hover {
  color: #fff;
}
.topbar .nav .shopCart {
  width: 120px;
  background: #424242;
}
.topbar .nav .shopCart:hover {
  background: #fff;
}
.topbar .nav .shopCart:hover a {
  color: #ff6700;
}
.topbar .nav .shopCart-full {
  width: 120px;
  background: #ff6700;
}
.topbar .nav .shopCart-full a {
  color: white;
}
/* 顶部导航栏CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 1225px;
  margin: 0 auto;
}
.el-header .logo {
  height: 60px;
  width: 339px;
  float: left;
  margin-right: 100px;
  position: relative;
}
.el-header .so {
  margin-top: 10px;
  width: 300px;
  position: absolute;
  right: 1%;

}
/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  text-align: center;
  background: #2f2f2f;
  padding-bottom: 20px;
}
.footer .ng-promise-box {
  border-bottom: 1px solid #3d3d3d;
  line-height: 145px;
}
.footer .ng-promise-box {
  margin: 0 auto;
  border-bottom: 1px solid #3d3d3d;
  line-height: 145px;
}
.footer .ng-promise-box .ng-promise p a {
  color: #fff;
  font-size: 20px;
  margin-right: 210px;
  padding-left: 44px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  text-decoration: none;
  background: url("assets/imgs/us-icon.png") no-repeat left 0;
}
.footer .github {
  height: 50px;
  line-height: 50px;
  margin-top: 20px;
}
.footer .github .github-but {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  background: url("assets/imgs/github.png") no-repeat;
}
.footer .mod_help {
  text-align: center;
  color: #888888;
}
.footer .mod_help p {
  margin: 20px 0 16px 0;
}

.footer .mod_help p a {
  color: #888888;
  text-decoration: none;
}
.footer .mod_help p a:hover {
  color: #fff;
}
.footer .mod_help p span {
  padding: 0 22px;
}
/* 底栏容器CSS END */

.flex-grow {
  flex-grow: 1;
}

li.el-menu-item{
  font-size: 18px;
}

</style>
